export default {
  install(Vue) {
    Vue.prototype.$dataLayer = new Vue({
      methods: {
        push(object) {
          if (!window.webpackHotUpdate) {
            window.dataLayer.push(object);
          }
        }
      }
    });
  }
};
